import { actionGenerator } from '../../utils/redux/actionGenerator';
import { EDrawingActionType } from './types';

export const finishDrawing = actionGenerator<EDrawingActionType.DrawingFinished>(EDrawingActionType.DrawingFinished);
